import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("mh_token");
      localStorage.removeItem("mh_user");
      const p = window.location.pathname;
      const isPublic =
        p === "/" ||
        p.startsWith("/login") ||
        p.startsWith("/signup") ||
        p.startsWith("/welcome") ||
        p.startsWith("/auth/callback");
      if (!isPublic) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
